module.exports = __webpack_public_path__ + "04d537b3344a37b5b7de71f2869d3857.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/floor_items/sandcastle.png
// module id = 1621
// module chunks = 0